import { UserIncludeEnum } from '../../../../enums/user-include.enum';

/**
 * Comprehensive includes for PersonalInfoPage
 *
 * All components on the profile page should use this same array to ensure:
 * 1. Single API call (efficient)
 * 2. Single RTK Query cache entry (consistent)
 * 3. All components see the same data (reliable)
 *
 * Used by:
 * - ProfileCard (needs: careers, userSportBackgrounds, company)
 * - ProfileBackground (needs: careers, userSportBackgrounds, company)
 * - AboutTab (needs: educations, workExperiences)
 * - SportExperienceTab (needs: userSportBackgrounds with nested careers)
 */
export const PROFILE_PAGE_INCLUDES: UserIncludeEnum[] = [
  UserIncludeEnum.CAREERS, // Sport career details (computed: sportsWithExperience)
  UserIncludeEnum.USER_SPORT_BACKGROUNDS, // Sport backgrounds (computed: totalExperienceYears, includes nested careers)
  UserIncludeEnum.COMPANY, // Company profile (for company users)
  UserIncludeEnum.EDUCATIONS, // Education history (AboutTab)
  UserIncludeEnum.WORK_EXPERIENCES, // Work experience history (AboutTab)
];
